<template>
  <div class="navbar">
    <div class="navbar-logo">
      <router-link to="/"><img src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/tjusls-logo-cut.png" height="40"></router-link>
    </div>
    <div class="navbar-list">
      <ul>
        <li>
          <a>Project</a>
          <ul>
            <li><router-link to="/description">Description</router-link></li>
            <li><router-link to="/design">Design</router-link></li>
            <li><router-link to="/engineering">Engineering</router-link></li>
            <li><router-link to="/experiments">Experiments</router-link></li>
            <li><router-link to="/results">Results</router-link></li>
            <li><router-link to="/implementation">Implementation</router-link></li>
            <li><router-link to="/contribution">Contribution</router-link></li>
            <li><router-link to="/safety">Safety</router-link></li>
            <li><router-link to="/proof-of-concept">Proof of Concept</router-link></li>
            <li><router-link to="/notebook">Notebook</router-link></li>
          </ul>
        </li>
        <li>
          <router-link to="/parts">Parts</router-link>
        </li>
        <li>
          <a>Model</a>
          <ul>
            <li><router-link to="/model">Modeling</router-link></li>
            <li><router-link to="/software">Software</router-link></li>
            <li><router-link to="/hardware">Hardware</router-link></li>
          </ul>
        </li>
        <li>
          <a>Human Practices</a>
          <ul>
            <li><router-link to="/human-overview">Overview</router-link></li>
            <li><router-link to="/human-practices">Integrated Human Practices</router-link></li>
            <li><router-link to="/communication">Science Communication</router-link></li>
            <li><router-link to="/game">Game: Synthetic Biosphere</router-link></li>
          </ul>
        </li>
        <li>
          <a>Team</a>
          <ul>
            <li><router-link to="/team">Team Members</router-link></li>
            <li><router-link to="/attributions">Attributions</router-link></li>
            <li><router-link to="/collaborations">Collaborations</router-link></li>
            <li><router-link to="/partnership">Partnership</router-link></li>
          </ul>
        </li>
        <li>
          <a>Judging</a>
          <ul>
            <li><router-link to="/judging">Judging Form</router-link></li>
            <li><router-link to="/judge-education">Best Education</router-link></li>
            <li><router-link to="/judge-hp">Best Integrated Human Practices</router-link></li>
            <li><router-link to="/judge-model">Best Model</router-link></li>
            <li><router-link to="/judge-basic-parts">Best New Basic Part</router-link></li>
            <li><router-link to="/judge-nc-part">Best New Composite Part</router-link></li>
            <li><router-link to="/judge-part-collection">Best Part Collection</router-link></li>
            <li><router-link to="/awards">Awards</router-link></li>
          </ul>
        </li>
      </ul>
    </div>
      <div class="navbar-home">
        <router-link to="/">
          <svg
              version="1.1"
              id="svg225834"
              width="25.000124"
              height="24.611971"
              xmlns="http://www.w3.org/2000/svg">
            <g
                id="g225840"
                transform="translate(-1741.2,-36.95)">
              <path
                  class="st57"
                  d="m 1765.503,46.321084 c -2.4028,-1.990926 -5.9041,-5.011642 -10.3665,-8.85619 -0.8238,-0.686526 -1.9909,-0.686526 -2.8148,0 -4.4624,3.844548 -7.895,6.796611 -10.3665,8.85619 -0.4119,0.411916 -0.7552,0.961137 -0.7552,1.510359 0,1.098442 0.8925,1.990927 1.9909,1.990927 h 1.3731 v 10.229243 c 0,0.823832 0.6865,1.510358 1.5103,1.510358 h 4.5998 c 0.8237,0 1.5103,-0.686526 1.5103,-1.510358 v -5.904127 h 3.0207 v 5.904127 c 0,0.823832 0.6866,1.510358 1.5104,1.510358 h 4.5997 c 0.8239,0 1.5104,-0.686526 1.5104,-1.510358 V 49.82237 h 1.3731 c 1.0984,0 1.9909,-0.892485 1.9909,-1.990927 0.069,-0.617874 -0.206,-1.167095 -0.6866,-1.510359 z m -1.2357,1.716317 h -1.6477 c -0.8238,0 -1.5103,0.686526 -1.5103,1.510358 v 10.229243 h -3.9819 v -5.835474 c 0,-0.823832 -0.6865,-1.510358 -1.5103,-1.510358 h -3.6386 c -0.8239,0 -1.5103,0.686526 -1.5103,1.510358 v 5.904127 h -3.9819 V 49.547759 c 0,-0.823832 -0.6865,-1.510358 -1.5104,-1.510358 h -1.6477 c -0.1373,0 -0.2059,-0.06865 -0.2059,-0.205958 0,-0.06865 0.069,-0.137305 0.069,-0.205958 2.4029,-1.990927 5.9042,-5.011643 10.3666,-8.856191 0.1372,-0.137305 0.2747,-0.137305 0.4119,0 4.4624,3.844548 7.8951,6.796611 10.3665,8.856191 0.069,0.06865 0.069,0.06865 0.069,0.137306 0,0.205957 -0.069,0.27461 -0.1373,0.27461 z m 0,0"
                  id="path176724"
                  style="fill:#fcfcfc;stroke-width:0.686526" />
            </g>
          </svg>
        </router-link>
      </div>
    <div class="navbar-toggle" @click="this.toggle  = !this.toggle" :style="this.toggle?'transform:rotate(-90deg)':''">
      <div :style="this.toggle?'transform: rotate(-30deg) translate(-6px,3px);width:15px':''"></div>
      <div :style="this.toggle?'width:21px':''"></div>
      <div :style="this.toggle?'transform: rotate(30deg) translate(-6px,-3px);width:15px':''"></div>

    </div>

  </div>
  <div class="navbar-list-mobi">
      <div class="navbar-list-mobi-first" @click="onFirstCatalogClick(0)">
        <div>Project</div>
        <div class="navbar-list-mobi-second" v-if="this.active===0">
          <div @click = "this.toggle = false"><router-link to="/description">Description</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/design">Design</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/engineering">Engineering</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/experiments">Experiments</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/results">Results</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/implementation">Implementation</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/contribution">Contribution</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/safety">Safety</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/proof-of-concept">Proof of Concept</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/notebook">Notebook</router-link></div>
        </div>
      </div>
      <div class="navbar-list-mobi-first">
        <div @click = "this.toggle = false"><router-link style="color: white" to="/parts-overview">Parts</router-link></div>
      </div>
      <div class="navbar-list-mobi-first" @click="onFirstCatalogClick(2)">
        <div>Model</div>
        <div class="navbar-list-mobi-second" v-if="this.active===2">
          <div @click = "this.toggle = false"><router-link to="/model">Modeling</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/software">Software</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/hardware">Hardware</router-link></div>
        </div>
      </div>
      <div class="navbar-list-mobi-first" @click="onFirstCatalogClick(3)">
        <div>Human Practices</div>
        <div class="navbar-list-mobi-second"  v-if="this.active===3">
          <div @click = "this.toggle = false"><router-link to="/human-overview">Overview</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/human-practices">Integrated Human Practices</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/communication">Science Communication</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/game">Game: Synthetic Biosphere</router-link></div>
        </div>
      </div>
      <div class="navbar-list-mobi-first" @click="onFirstCatalogClick(4)">
        <div>Team</div>
        <div class="navbar-list-mobi-second" v-if="this.active===4">
          <div @click = "this.toggle = false"><router-link to="/team">Team Members</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/attributions">Attributions</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/collaborations">Collaborations</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/partnership">Partnership</router-link></div>
        </div>
      </div>
      <div class="navbar-list-mobi-first" @click="onFirstCatalogClick(5)">
        <div>Judging</div>
        <div class="navbar-list-mobi-second" v-if="this.active===5">
          <div @click = "this.toggle = false"><router-link to="/judging">Judging Form</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-education">Best Education</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-hp">Best Integrated Human Practices</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-model">Best Model</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-basic-parts">Best New Basic Part</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-nc-part">Best New Composite Part</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/judge-part-collection">Best Part Collection</router-link></div>
          <div @click = "this.toggle = false"><router-link to="/awards">Awards</router-link></div>
        </div>
      </div>
  </div>
<!--  <span style="height: 60px"></span>-->
</template>
<script>
import gsap from "gsap"
export default {
  name: 'TopNavBar',
  props: {},
  data(){
    return{
      active:-1,
      toggle:false
    }
  },methods:{
    onFirstCatalogClick(i){
      this.active === i?this.active=-1:this.active=i;
    }
    },
    watch:{
      toggle(){
        gsap.to(".navbar-list-mobi",{
          opacity:this.toggle?1:0,
          top:this.toggle?60:-600,
          // duration:0.7
        })
      }
    },mounted() {
  }
}
</script>
<style scoped>


.navbar{
  position: fixed;
  height: 60px;
  left: 0;
  right: 0;
  top: 0;
  background-color: #4978f3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 0 3px 5px rgba(0,0,0,0.5);
  z-index: 9;
}
.navbar-toggle{
  display: none;
}
.navbar-logo{
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.navbar-logo > a{
  margin-left: 40px;
}

.navbar-home{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 25px;
  margin-right: 40px;
}

/*.navbar-home > a{*/
/*  margin-right: 40px;*/
/*}*/

li{
  list-style-type: none;
}
.navbar-list > ul {
  padding: 0;
  margin-block-start: 16px;
  margin-block-end: 0;
}
.navbar-list > ul > li{
  float: left;
  margin-right: 18px;
  margin-left: 18px;
  /*width: 50px;*/
}

.navbar-list > ul > li > ul{
  padding: 0;
  background-color: #4673ea;
  /*width: 120px;*/
  margin-top: 5px;
  display: none;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  box-shadow: 3px 3px 5px rgba(0,0,0,0.5);
  position: absolute;
}
.navbar-list > ul > li > ul > li:hover{
  background-color: #4470e2;
}
.navbar-list > ul > li:hover > ul{
  display: flex;
}
.navbar-list > ul > li > ul > li {
  padding: 3px 7px;
  min-width: 110px;
  /*width: inherit;*/
  /*padding-left: 7px;*/
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.navbar-list > ul > li > a{
  padding: 6px;
}
.navbar-list > ul > li > ul > li > a,.navbar-list > ul > li > a{
  color: white;
  font-size: 32px;
  margin-left: 0;
  font-family:catalogfont;
}
.navbar-list > ul > li > ul > li > a {
  font-size: 26px;
}
.navbar-list-mobi{
  display: none;
}
@media screen and (max-width: 880px){
  .navbar-home{
    display: none;
  }
  .navbar-toggle{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    transition: all 500ms;
  }
  .navbar-toggle > div{
    height: 3px;
    width: 25px;
    background-color: white;
    margin: 3px;
    transition: all 500ms;
  }
  .navbar-list > ul > li{
    margin-left: 5px;
    margin-right: 5px;
  }
  .navbar{
    height: auto;
    min-height: 60px;
  }
  .navbar-list{
    display: none;
  }
  .navbar-list-mobi{
    opacity: 0;
    top: -600px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100vw;
    transition: max-height 1s;
    position: fixed;
    background-color: #4978f3;
    z-index: 8;
  }
  .navbar-list-mobi-first{
    padding: 5px 30px;
    color: white;
    font-family: catalogfont;
    font-size: 30px;
    width: inherit;
  }
  .navbar-list-mobi-first > div:nth-child(1):after{
    content: "▴";
    font-size: 20px;
    transform: rotate(180deg);
    right: 20px;
    position: absolute;
  }
  .navbar-list-mobi-first > div,.navbar-list-mobi-second > div{
    width: inherit;
  }
  .navbar-list-mobi-second{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 3px 10px;
    color: white;
    font-family: catalogfont;
    font-size: 20px;
    width: inherit;
  }
  div.navbar-list-mobi-second > div > a{
    color: white;
  }
}
</style>